import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppropriatenessModalComponent } from "./appropriateness-modal/appropriateness-modal.component";
import { FeaturedAssetsComponent } from "./featured-assets/featured-assets.component";
import { StockToggleComponent } from "./stock-toggle/stock-toggle.component";
import { CoreModule } from "../../../core/core.module";

const components = [AppropriatenessModalComponent, FeaturedAssetsComponent, StockToggleComponent];

@NgModule({
	imports: [CommonModule, CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class StocksModule {}
